import axios from "axios";
import { FileTypeResult } from "file-type";

interface uploadPhotoProps {
  resData: { signedPutRequest: string; url: string };
  imageUrl: string;
  imageType?: FileTypeResult;
}

/**
 * This function handles the upload for both web and mobile photos.
 * Returns the url of the image on AWS, which we get from the HTTP request
 * @param resData aquired slightly different for web and mobile uploads, the http response
 * @param imageUrl is the base64 image data provided by the user
 */
export const uploadPhotoToAWS = async ({ resData, imageUrl, imageType }: uploadPhotoProps) => {
  // Decode base64 to binary data using native browser APIs
  const base64String = imageUrl.replace(/^data:image\/\w+;base64,/, "");
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const base64Data = bytes;
  const { signedPutRequest, url } = resData;
  await axios.put(signedPutRequest, base64Data, {
    headers: {
      "Content-Type": imageType ? imageType.mime : "image/jpeg",
      Accept: "*/*",
    },
  });
  return url;
};
